import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { of } from 'rxjs';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';

import { IEjecucionPalanca, IResulApi } from '../../private/shared/models/task-ejecucion';
import { EJECUCION_ENDPOINTS } from '../../shared/models/Constants';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    errorEjecucionTarea,
    errorGetResultEjecucion,
    errorSendEjecucionIncidencia,
    errorSendEjecucionTarea,
    getEjecucionTarea,
    getResultEjecucion,
    sendEjecucionIncidencia,
    sendEjecucionTarea,
    setTaskCompleted,
    successEjecucionTarea,
    successGetResultEjecucion,
    successSendEjecucionIncidencia,
    successSendEjecucionTarea,
} from '../actions';
import { AppState } from '../app-reducers';

@Injectable()
export class EjecucionEffets {
    constructor(
        private actions$: Actions
        , private httpS: SharedServiceService
        , private store: Store<AppState>
    ) { }

    /**
     * Obtiene las palancas comerciales, si tiene tarea o no
     */
    public getEjecucionTarea$ = createEffect(
        () => this.actions$.pipe(
            ofType(getEjecucionTarea),
            switchMap(() => this.store.select('userData').pipe(map(value => value.Ejecucion.ID_Tendero), take(1))),
            switchMap(ID_Tendero =>
                this.httpS.executeRequestByUser(EJECUCION_ENDPOINTS.post_get_execution_config, { ID_Tendero, offset: (moment().utcOffset() / 60) })
                    .pipe(
                        map(resp => successEjecucionTarea(resp)),
                        catchError((err: Error) => of(errorEjecucionTarea({ payload: err })))
                    )
            )
        )
    );

    /**
     * Envia la tarea de ejecucion
     */
    public sendEjecucionTarea$ = createEffect(
        () => this.actions$.pipe(
            ofType(sendEjecucionTarea),
            switchMap(actions => this.httpS.executeRequestByUser(EJECUCION_ENDPOINTS.post_upload_execution, actions)
                .pipe(
                    tap((resp: IResulApi) => setTaskCompleted({ tasks: resp.data as IEjecucionPalanca[] })),
                    map((resp: IResulApi) => successSendEjecucionTarea(resp)),
                    catchError((err: Error) => of(errorSendEjecucionTarea({ payload: err })))
                )
            )
        )
    );

    /**
     * Envia comentarios de ejecucion
     */
    public sendEjecucionIncidencia$ = createEffect(
        () => this.actions$.pipe(
            ofType(sendEjecucionIncidencia),
            switchMap(actions => this.httpS.executeRequestByUser(EJECUCION_ENDPOINTS.post_save_execution_incidence, actions)
                .pipe(
                    map(resp => successSendEjecucionIncidencia(resp)),
                    catchError((err: Error) => of(errorSendEjecucionIncidencia({ payload: err })))
                )
            )
        )
    );

    /**
     * Obtiene los resultados de ejecucion
     */
    public getResultEjecucion$ = createEffect(
        () => this.actions$.pipe(
            ofType(getResultEjecucion),
            switchMap(actions => this.httpS.executeRequestByUser(EJECUCION_ENDPOINTS.get_self_assessment_results, actions)
                .pipe(
                    map(resp => successGetResultEjecucion(resp)),
                    catchError((err: Error) => of(errorGetResultEjecucion({ payload: err })))
                )
            )
        )
    );

}